import * as React from "react";
import { LOBState } from "src/stores/wizard/state";
import { UitkLayoutConditionalGridSpan, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { useLocalization } from "@shared-ui/localization-context";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { CobrandImage } from "components/shared/CobrandImage/CobrandImage";
import { GlobalConfig } from "stores/wizard/config";
import { CheckboxModuleNameTypes } from "src/components/shared/PropertyFIlterComponents/components/Checkbox";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);

export interface SubmitButtonProps {
  lobState: LOBState;
  colSpan?: UitkLayoutConditionalGridSpan;
  className?: string;
  rfrr?: string;
  uisPrimeMicroMessages?: object[];
  subText?: string;
  globalConfig?: GlobalConfig;
  disabled?: boolean;
  moduleName?: string;
  testId?: string;
}

export const SubmitButton: React.FunctionComponent<SubmitButtonProps> = ({
  colSpan,
  lobState,
  className,
  rfrr,
  uisPrimeMicroMessages,
  subText,
  globalConfig,
  disabled,
  moduleName,
  testId = "submit-button",
}) => {
  const { formatText } = useLocalization();
  const moduleNameType = moduleName === CheckboxModuleNameTypes.WIZARD_HOTEL_V2_HTG ? moduleName : "StorefrontWizard";

  return (
    <UitkLayoutGridItem colSpan={colSpan} className={className ? className : ""}>
      <div>
        <ButtonTracked
          data-testid={testId}
          tag="button"
          type="submit"
          text={formatText(lobState.config.form.submitButton.locToken)}
          size={UitkButtonSize.LARGE}
          isFullWidth={true}
          moduleName={moduleNameType}
          rfrr={rfrr || `SearchClick_NA`}
          uisPrimeMicroMessages={uisPrimeMicroMessages}
          subText={subText}
          disabled={disabled}
        />
        <CobrandImage globalConfig={globalConfig} />
      </div>
    </UitkLayoutGridItem>
  );
};
